import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchAndFilter } from './SearchAndFilter';
import { useCategories } from '../../hooks/useCategories'; 

interface ExpertWrapperProps {
  searchTerm: string;
  setSearchTerm: (val: string) => void;
  activeCategory: string;
  children: React.ReactNode;
  
  // Made optional so you don't have to remove them from Astronomy/Lawyer/Doctor pages
  loading?: boolean; 
  error?: string | null;
  
  sortBy?: 'price' | 'rating' | 'experience';
  setSortBy: (val?: 'price' | 'rating' | 'experience') => void;
  sortOrder?: 'ASC' | 'DESC';
  setSortOrder: (val?: 'ASC' | 'DESC') => void;
  minRating?: number;
  setMinRating: (val?: number) => void;
}

export const ExpertWrapper: React.FC<ExpertWrapperProps> = ({
  searchTerm, setSearchTerm, activeCategory, children,
  sortBy, setSortBy, sortOrder, setSortOrder, minRating, setMinRating
}) => {
  const { categories, loading: categoriesLoading } = useCategories();
  const navigate = useNavigate();

  const handleNavigation = (category: string) => {
    navigate(`/experts/${category.toLowerCase()}`);
  };

  const categoryNames = useMemo(() => {
    if (!categories || categories.length === 0) {
      return ['Astrology', 'Lawyer', 'Doctor'];
    }
    return categories.map((cat: any) => cat.name || cat.category_name || 'Unknown');
  }, [categories]);

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      
      <SearchAndFilter 
        searchTerm={searchTerm} setSearchTerm={setSearchTerm}
        activeCategory={activeCategory} categories={categoryNames} 
        loadingCategories={categoriesLoading} onCategoryClick={handleNavigation}
        sortBy={sortBy} setSortBy={setSortBy}
        sortOrder={sortOrder} setSortOrder={setSortOrder}
        minRating={minRating} setMinRating={setMinRating}
      />

      <div className="p-4 md:p-6 mt-8 max-w-7xl mx-auto">
        {children}
      </div>

    </div>
  );
};